<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { each, find, remove } from 'lodash'

export default {
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    }
  },

  watch: {
    value: 'valueUpdated'
  },

  data () {
    return {
      registeredOptions: []
    }
  },

  methods: {
    registerOption (option) {
      this.registeredOptions.push(option)

      option.instance.valueUpdated(this.value)
    },

    unregisterOption (option) {
      remove(this.registeredOptions,
        registeredOption => registeredOption.instance === option.instance)
    },

    updateOption (option) {
      find(this.registeredOptions,
        registeredOption => registeredOption.instance === option.instance)
        .value = option.value

      // We call this function to let the updated option know what the currently selected value is
      option.instance.valueUpdated(this.value)
    },

    optionClicked (option) {
      this.$emit('input', option.value)
    },

    valueUpdated () {
      each(this.registeredOptions, option => {
        option.instance.valueUpdated(this.value)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Radio/Radio.vue